import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "withdraw-submitted" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "withdraw-submitted-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "header-title" }, "Withdrawal Submitted!")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "amount-withdrawal" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "currency" }, "$", -1 /* HOISTED */)
const _hoisted_5 = { class: "amount" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "extra-info" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "withdraw-info" }, "You should receive your money in your  "),
  /*#__PURE__*/_createElementVNode("span", { class: "bank-name" }, "connected account  "),
  /*#__PURE__*/_createElementVNode("span", { class: "withdraw-info" }, "within 2 - 3 business days.")
], -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, _toDisplayString($setup.confirmedAmount), 1 /* TEXT */)
      ]),
      _hoisted_6
    ]),
    _createElementVNode("div", { class: "button-container withdraw-submitted-btn" }, [
      _createElementVNode("button", {
        class: "borderless",
        onClick: $setup.routeTo
      }, "Back to Balance")
    ])
  ], 64 /* STABLE_FRAGMENT */))
}